export default "__VITE_ASSET__BDlpBEA3__"